import React from "react";

import { BaseFormatter } from "@platformsh/observability-graph/Formatter";

import * as S from "./FlamebearerCallTooltip.styles";
import { getSimpleDelta } from "./utils";

const availableOpacities = [
  -1, -0.8, -0.6, -0.4, -0.2, 0, 0.2, 0.4, 0.6, 0.8, 1
];

type Props = {
  valueA: number;
  valueB: number;
  diffPeak: number;
  formatter: BaseFormatter;
};

const ComparisonFlamebearerCallTooltipColorScale = ({
  valueA,
  valueB,
  diffPeak,
  formatter
}: Props) => {
  const percentageOfPeak = diffPeak === 0 ? 0 : (valueB - valueA) / diffPeak;
  const diff = formatter.toCondensedString(Math.abs(valueB - valueA));

  let sign = "";
  if (Math.sign(percentageOfPeak) > 0) {
    sign = "+";
  } else if (Math.sign(percentageOfPeak) < 0) {
    sign = "-";
  }
  const cursorText = `${sign} ${diff}`.trim();
  const cursorLeftPercent = (1 + percentageOfPeak) * 50;

  return (
    <S.Scale>
      <S.ScaleInner>
        <S.ScaleBackground>
          {availableOpacities.map(opacity => (
            <S.ScaleBackgroundCell
              key={opacity}
              delta={getSimpleDelta(opacity)}
              style={{ opacity: Math.abs(opacity) }}
            />
          ))}
        </S.ScaleBackground>
        <S.ScaleText style={{ left: `${cursorLeftPercent}%` }}>
          <S.ScaleTextMarker />
          <S.ScaleTextLabel>{cursorText}</S.ScaleTextLabel>
        </S.ScaleText>
      </S.ScaleInner>
    </S.Scale>
  );
};

export default ComparisonFlamebearerCallTooltipColorScale;
